import React, { memo, type ReactNode } from 'react';

import { useRenderServerPlaceholder } from '@confluence/ssr-utilities/entry-points/useRenderServerPlaceholder.ts';

export interface HydrationSafeComponentProps {
	children: ReactNode;
	isEnabled?: boolean;
}

const HydrationSafeComponentContent = memo(
	function HydrationSafeComponentContent({ children }: { isLocked: boolean; children: ReactNode }) {
		return <>{children}</>;
	},
	(_prevProps, nextProps) => {
		// Block updates while locked (during hydration)
		return nextProps.isLocked;
	},
);

export function HydrationSafeComponent({
	children,
	isEnabled = true,
}: HydrationSafeComponentProps): React.JSX.Element {
	const renderServerPlaceholder = useRenderServerPlaceholder();

	if (!isEnabled) {
		return <>{children}</>;
	}

	return (
		<HydrationSafeComponentContent isLocked={renderServerPlaceholder}>
			{children}
		</HydrationSafeComponentContent>
	);
}
